// src/assets/wrappers/LandscapeAdvertis.styles.js
import styled from "styled-components";

export const AdvertGrid = styled.div`
  display: grid;
  height: 100vh;
  width: 100%;
  grid-template-rows: 120px 1fr 150px;
  grid-template-columns: 1fr;

  background: ${(props) =>
    props.backgroundImage
      ? `url(${props.backgroundImage})`
      : props.background || "transparent"};
  background-size: cover;
  background-position: center;
`;

export const TopSection = styled.div`
  grid-row: 1;
  width: 100%;
  height: 100%;
`;

export const MiddleSection = styled.div`
  grid-row: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden; 
`;

export const BottomSection = styled.div`
  grid-row: 3;
  width: 100%;
  height: 100%;
  /* אפשר להוסיף פס עיטוף פנימי אם תרצו: padding: 10px; */
`;
